// main component
import { useContext, useEffect, useState } from 'react';
import { useForm, useFieldArray, SubmitHandler, Controller} from "react-hook-form";
import { Link, useParams, useNavigate } from "react-router-dom";

import StateContext from '../stateContext';
import axios from 'axios';

import WorkguildIntroCover from './imgs/workguild_video_cover.png';
import WorkguildIntro from './video/WorkguildIntro.mp4'; 

function SuggestedListings() {

  const navigate = useNavigate();

  // get current path
  const curPath = window.location.pathname;

  // get params
  const { role, pageNumber, pPageSize } = useParams();

  var initSearch = role != undefined && role != "" ? role.replaceAll("_", " ").trim() : '';

  // get state context
  const { createNotification, applicationStati, userInfo, validUserCreds, setPopup} = useContext(StateContext);
  const [ listings, setListings ] = useState([]);
  const [ totalListingCount, setTotalListingCount] = useState(0);
  const [ search, setSearch ] = useState(initSearch);
  const [ searchInput, setSearchInput ] = useState(initSearch);

  // filter menu
  const [ filterMenuVis, setFilterMenuVis ] = useState(false);
  const [ navMenuVis, setNavMenuVis ] = useState(false);
  const [ filters, setFilters ] = useState({});
  const [ searchingListing, setSearchingListing] = useState(true);
  const [ maxListingReached, setMaxListingReached ] = useState(false);

  // determine if pageNumber and pPageSize are valid
  var offset = 0;
  var pageSize = 0;
  if (parseInt(pPageSize) > 0) {
    pageSize = parseInt(pPageSize);
  } else {
    pageSize = 20;
  }

  if (parseInt(pageNumber) <= 1) {
    offset = 0;
  } else if (parseInt(pageNumber) > 0) {
    offset = (parseInt(pageNumber) - 1) * pageSize;
  }

  const {
    getValues,
    register,
    handleSubmit,
    control,
    reset: resetFilters,
    formState: { errors }
  } = useForm({
    defaultValues: {
      date_posted_option: undefined
    }
  });

  function filterApplied() {
    const curFilters = getValues()
    for (const filterKey in curFilters) {
      if (typeof(curFilters[filterKey]) == "string" || (Number.isFinite(curFilters[filterKey]))) {
        return true;
      }
    }
    
    return false;
  }

  function applyFilters(fData) {

    const regex = /\/\d+\/\d+$/;
    if (regex.test(curPath.toLowerCase())) {
      navigate(curPath.replace(regex, ""))
    }

    setFilters(fData);
    setFilterMenuVis(false);
  }

  // get all listings with the selected status
  useEffect(() => {

    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    var validSearch = "";
    if (search.length > 0) {
      validSearch = search
    }

    setSearchingListing(true);

    var data = {
      "pageSize": pageSize,
      "offset": offset, 
      "search": validSearch,
      "filters": getValues()
    }

    // check if okay to pass user creds
    if (validUserCreds() == true) {
      if (curPath.toLowerCase().startsWith("/suggested")) {
        data = {
          "suggested": true,
          "pageSize": pageSize,
          "offset": offset, 
          "email": userInfo.email,
          "jwt": userInfo.jwt,
        }
      } else {
        data = {
          ...data,
          "email": userInfo.email,
          "jwt": userInfo.jwt,
        }
      } 
    }

    axios.post(
      '/api/listings/suggestions',
    data
    ).then((response) => {
      setSearchingListing(false);
      if (response.status == 200 && response.data.success == true) {
        if (response.data.results > 0) {
          setListings(response.data.result.listings)
          setTotalListingCount(response.data.result.listingCount)
        } else {
          setListings([])
        }
      } else {
        // prompt error 
        createNotification({
          "status": "error",
          "msg": "Error while searching listings",
        })
      }
    })
  }, [ pageSize, offset, userInfo]);
  

  async function generateResume(listingIndex) {

    if (!validUserCreds()) {
      // alert user that they need to login
      setPopup({type: "login", "msg": "Become a WorkGuild Premium Member to Generate Resumes!"});
      return;
    }

    // check if user is premium
    if (userInfo.account_type != "premium") {
      setPopup({type: "subscribe", "msg": "Become a WorkGuild Premium Member to Generate Resumes!"});
      return;
    }

    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
      '/api/resume/create',
      {
        "email": userInfo.email,
        "jwt": userInfo.jwt,
        "application_id": listings[listingIndex].applicationDetails["result"]["id"]
      }
      ).then((response) => {

        if (response.status == 200 && response.data.success == true && response.data.results > 0) {
          // update application id's resume status

          var updatedListings = [...listings];
          updatedListings[listingIndex].applicationDetails.result.gen_resume_status = response.data.result.status;
          setListings(updatedListings);

          // notify user of success
          createNotification({
            "status": "success",
            "msg": "Resume generation task success!",
          })
          
        } else if (response.data instanceof Object && response.data.result.subscription_needed == true) {
          setPopup({type: "subscribe", "msg": "Join WorkGuild Premium!"});
        } else if (response.data instanceof Object && response.data.result.missing_info && response.data.result.missing_info.length > 0) {
          setPopup({type: "resume_gen_info_missing", msg: "Join WorkGuild Premium!", missingInfo: response.data.result.missing_info});
        } else {
          // prompt error 
          createNotification({
            "status": "error",
            "msg": "Error while generating resume task!",
          })
        }
    })
  }

  async function updateApplicationStatus(listingIndex, appID, newApplicationStatus ) {

    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;
    
    axios.patch(
        '/api/application/update',
      {
        "email": userInfo.email,
        "jwt": userInfo.jwt,
        "new_application_status": newApplicationStatus,
        "application_id": appID
      }
      ).then((response) => {
          if (response.status == 200 && response.data.success == true && response.data.results > 0) {
            if (response.data.results <= 0 ) {
              createNotification({
                "status": "error",
                "msg": "Error while updating application status!",
              })
            } else {
              var updatedListings = [...listings];
              updatedListings[listingIndex].applicationDetails.result.id = response.data.result.id;
              updatedListings[listingIndex].applicationDetails.result.status = response.data.result.status;
              setListings(updatedListings);

              createNotification({
                "status": "success",
                "msg": "Application status updated!",
              })

            }
          } else {
            // prompt error 
            createNotification({
              "status": "error",
              "msg": "Error while updating application status!",
            })
          }
      })
  }

  async function trackListing(listingIndex) {

    if (!validUserCreds()) {
      // alert user that they need to login
      setPopup({type: "login", "msg": "Login to Track Applications"});
      return;
    }
    
    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
        '/api/application/create',
      {
        "email": userInfo.email,
        "jwt": userInfo.jwt,
        "listing_id": listings[listingIndex].id,
      }
      ).then((response) => {
          if (response.status == 200 && response.data.success == true && response.data.results > 0) {

            var updatedListings = [...listings];
            updatedListings[listingIndex].applicationDetails = response.data;
            setListings(updatedListings);

            createNotification({
              "status": "success",
              "msg": "Tracking job listing updated!",
            })
          } else {
            // prompt error 
            createNotification({
              "status": "error",
              "msg": "Error tracking listing!",
            })
          }
      })
  }

  // determine max number of pages
  var maxPageCount = parseInt(totalListingCount / pageSize);
  if (parseInt(totalListingCount / pageSize) - maxPageCount > 0) {
    maxPageCount++;
  }

  // determine current page number
  var cPageNumber = 1;
  if (parseInt(pageNumber) > 1) {
    cPageNumber = parseInt(pageNumber);
  }

  if (parseInt(pageNumber) > maxPageCount) {
    cPageNumber = maxPageCount + 1;
  }

  var pageNavigationLinks = [<Link className="currentPage navPageLinks" key={cPageNumber}>{parseInt(cPageNumber)}</Link>]

  // determine left of page number
  for (var i = cPageNumber; i > cPageNumber - 1 && i > 1; i--) {
    pageNavigationLinks.unshift(<Link className="navPageLinks" to={`/${curPath.toLowerCase().startsWith("/suggested") ? "suggested" : "home"}/${typeof(search) == "string" && search.length > 0 ? search.replaceAll(" ", "_") + "/": ""}${i - 1}/${pageSize}`} key={i - 1}>{i - 1}</Link>)
  }

  // determine right of page number
  for (var i = parseInt(cPageNumber) + 1; i < cPageNumber + 2 && i < maxPageCount + 2; i++) {
    if (i * pageSize > 60 && validUserCreds() != true) {
      pageNavigationLinks.push(<button onClick={() => {setPopup({type: "login", "msg": "Login to see more!"});}} style={{backgroundColor: "transparent", fontWeight: "normal"}} key={i}>{i}</button> )
    } else {
      pageNavigationLinks.push(<Link className="navPageLinks" to={`/${curPath.toLowerCase().startsWith("/suggested") ? "suggested" : "home"}/${typeof(search) == "string" && search.length > 0 ? search.replaceAll(" ", "_")  + "/": ""}${i}/${pageSize}`} key={i}>{i}</Link>)
    }
  }

  // determine no listing msg/str
  var noListingMsg = "";
  if (searchingListing == true) {
    noListingMsg = "Loading listings..."
  } else if(maxListingReached == true) {
    noListingMsg = "Login to see more listings!"
  } else {
    noListingMsg = "No listings found"
    if (search.length > 0 ) {
      noListingMsg = `${noListingMsg} for search '${search}'`
    }

    if (typeof(filters["location"]) == 'string' && filters["location"].length > 0) {
      noListingMsg = `${noListingMsg} with location '${filters["location"]}'`
    }
  }

  return (
    <>
      <main style={ 
        curPath.toLowerCase().startsWith("/suggested") ? 
        {
          gridTemplateRows: "auto",
          gridTemplateAreas: `". content content ."`,
          gridTemplateColumns: "1fr minmax(200px, 350px) minmax(200px, 350px) 1fr"

        } : undefined}>
        {validUserCreds() == true ?
          undefined
          :
          <section className="hero">
            <div 
              style={{
                gridArea: "heroMsg", display: "flex", flexDirection: "column", 
                justifyContent: "center", alignItems: "center", width: "100%"
              }}>
              <h2 style={{width: "100%", textAlign: "left"}} className="slogan">Avoid ghost jobs.<br/>Track applications.<br/>Accelerate your job search.</h2>
            </div>
            <Link to="/about" className="next sloganAction" style={{ gridArea: "heroLearnMore", width: "fit-content", height: "fit-content", padding: "10px", fontSize: "18px", color: "white", borderRadius: "5px", fontWeight: "bold"}}>Learn More</Link>
            <video width="100%" height="auto" className="introVideo" style={{ gridArea: "introVideo" }} poster={WorkguildIntroCover} controls>
              <source src={WorkguildIntro} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </section>
        }
        { curPath.toLowerCase().startsWith("/suggested") || initSearch != undefined && initSearch != "" ? 
          undefined :
          <section 
          style={{
            gridArea: "quickSearchLinks",
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gridTemplateRows: "max-content max-content max-content",
            gridTemplateAreas: `
                                "roleHeader roleHeader roleHeader"
                                "roleBtn0 roleBtn1 roleBtn2"
                                "roleBtn3 roleBtn4 roleBtn5
                                `,
            gap: "10px"
          }}
        >
          <h3 style={{textAlign: "center", gridArea: "roleHeader", height: "initial"}}>Search By Role</h3>
          {["engineer", "sales", "analyst", "manager", "support", "architect"].map((role, index) => {
            return <button 
              key={`roleQuickLink${index}`}
              style={{
                gridArea: `roleBtn${index}`, background: "none", fontSize: "18px", 
                paddingTop: "15px", paddingBottom: "15px", textAlign: "center",
                boxShadow: "0px 0px 2px #86888a", color: "black"
              }}
              onClick={() => {
                setSearchInput(role);
                navigate(`/home/${role}`)
              }}
              >
                {role.charAt(0).toUpperCase() + role.substring(1)}
              </button>
          })}
        </section>
        }
        <form className="searchBox" 
          style={curPath.toLowerCase().startsWith("/suggested") ? {display: "none"} : undefined } 
          onSubmit={(e) => {
            e.preventDefault(); 

            // get form data
            const formData = new FormData(e.target);
            const dataObject = Object.fromEntries(formData.entries());

            if (dataObject.listingSearch) {
              var listingSearch = dataObject.listingSearch.trim().replaceAll(" ", "_").toLowerCase()

              // navigate to listing search
              navigate(`/${curPath.toLowerCase().startsWith("/suggested") ? "suggested" : "home"}/${listingSearch}`)

              setSearch(dataObject.listingSearch.trim().toLowerCase())
              
            } else {
              navigate(`/home`);
              setSearch("")
            }
            
          }}
        >
          <input placeholder='Search Job Title or Company Name' name="listingSearch" 
          value={ searchInput != undefined ? searchInput : undefined} 
          onChange={(e) => {setSearchInput(e.target.value)}}
          />
          <button className='submit' type="submit">Search</button>
          <svg className="filterIcon" 
            onClick={() => {setFilterMenuVis(!filterMenuVis)}}
            style={ filterApplied() == true ? {backgroundColor: "#e7f6e7", fill: "#346432", padding: "5px", width: "10%", borderRadius: "5px", } : {backgroundColor: "transparent", color: "black", padding: "5px", width: "10%", borderRadius: "5px" } } 
            viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 4.6C2 4.03995 2 3.75992 2.10899 3.54601C2.20487 3.35785 2.35785 3.20487 2.54601 3.10899C2.75992 3 3.03995 3 3.6 3H20.4C20.9601 3 21.2401 3 21.454 3.10899C21.6422 3.20487 21.7951 3.35785 21.891 3.54601C22 3.75992 22 4.03995 22 4.6V5.26939C22 5.53819 22 5.67259 21.9672 5.79756C21.938 5.90831 21.8901 6.01323 21.8255 6.10776C21.7526 6.21443 21.651 6.30245 21.4479 6.4785L15.0521 12.0215C14.849 12.1975 14.7474 12.2856 14.6745 12.3922C14.6099 12.4868 14.562 12.5917 14.5328 12.7024C14.5 12.8274 14.5 12.9618 14.5 13.2306V18.4584C14.5 18.6539 14.5 18.7517 14.4685 18.8363C14.4406 18.911 14.3953 18.9779 14.3363 19.0315C14.2695 19.0922 14.1787 19.1285 13.9971 19.2012L10.5971 20.5612C10.2296 20.7082 10.0458 20.7817 9.89827 20.751C9.76927 20.7242 9.65605 20.6476 9.58325 20.5377C9.5 20.4122 9.5 20.2142 9.5 19.8184V13.2306C9.5 12.9618 9.5 12.8274 9.46715 12.7024C9.43805 12.5917 9.39014 12.4868 9.32551 12.3922C9.25258 12.2856 9.15102 12.1975 8.94789 12.0215L2.55211 6.4785C2.34898 6.30245 2.24742 6.21443 2.17449 6.10776C2.10986 6.01323 2.06195 5.90831 2.03285 5.79756C2 5.67259 2 5.53819 2 5.26939V4.6Z"/>
          </svg>
        </form>
        <section className='listings' >
          { maxListingReached == true || searchingListing == true || listings == undefined || listings.length <= 0 ?
            <h3>{noListingMsg}</h3>
            :
            listings.map((listing, index) => (
              <article key={index} 
                style={{
                  padding: "10px",
                  border: "solid #e1e1e1 1px",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px"
                }}
              >
                <section 
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 70px",
                    gridTemplateRows: "min-content auto auto",
                    gridTemplateAreas: `
                      "title title"
                      "companyName companyName"
                      "location age"
                    `,
                    width: "70%",
                    maxWidth: "70%",
                    textDecoration: "none",
                    alignItems: "start",
                    gap: "2px"
                  }}
                >
                  <a href={listing.link} target="_blank" rel="noreferrer" style={{ gridArea: "title", width: "100%", fontSize: "14px", fontWeight: "bold"}}>{listing.job_title}</a>
                  <a href={`/company/${listing.company_name}`} style={{ fontWeight: "normal", gridArea: "companyName", width: "100%", fontSize: "12px", display: "flex", flexDirection: "row", gap: "5px", alignItems: "center"}}>
                    <span>{listing.company_name_full}</span>
                    <svg width="10px" height="10px" viewBox="0 0 24 24" style={{color: "blue"}}fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </a>
                  <h5 style={{ fontWeight: "normal", gridArea: "location", width: "100%", marginTop: "5px", display: 'flex', gap: "5px", alignItems: "center", color: "#87898b"}}>
                    <svg width="10px" height="10px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>{listing.location}</span>
                  </h5>
                  <h5 style={{gridArea: "age", color: "#87898b", width: "100%", textAlign: "right"}}>{listing.age.lessThan == true ? "~" : undefined}{`${listing.age.time} ${listing.age.unit}`}{listing.age.time > 1 ? "s" : undefined }</h5>
                </section>
                <section
                  style={{
                    width: "30%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px"
                  }}
                >
                  { listing?.applicationDetails?.success == true && listing?.applicationDetails?.results > 0 ?
                  <>
                    <select className="submit-light" onChange={(e) => {updateApplicationStatus(index, listing.applicationDetails.result.id, e.target.selectedOptions[0].value)}} value={listing.applicationDetails.result.status}
                      style={{
                        padding: "5px",
                        border: "none",
                        borderRadius: "5px",
                        fontWeight: "bold",
                        textAlign: "center",
                        fontSize: "12px"
                      }}
                    >
                      {applicationStati.map((stati, index) => (
                        <option key={index} value={stati}>{stati.charAt(0).toUpperCase() + stati.slice(1)}</option>
                      ))}
                    </select>
                    {listing.validated == 1 && listing.applicationDetails.result.gen_resume_status == "ready" ? <Link className="next-light" style={{ fontSize: "12px", textAlign: "center", borderRadius: "5px", padding: "5px", fontWeight: "bold"}} to={"/resume/" + listing.applicationDetails.result.id}>View Resume</Link> : "" }
                    {listing.validated == 1 && listing.applicationDetails.result.gen_resume_status == "pending" ? <button className='warning-light' style={{fontWeight: "bold"}} >Resume Pending</button> : ""} 
                    {listing.validated == 1 && listing.applicationDetails.result.gen_resume_status == undefined ? <button className='subscribe' style={{ fontSize: "12px", fontWeight: "bold"}} onClick={() => {generateResume(index)}}>Generate Resume</button> : ""} 
                  </>  
                  :
                  <>
                    <button className="next" style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", fontSize: "12px"}} onClick={() => {trackListing(index)}}>
                      Track
                      <svg width="15px" height="15px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 7.8C5 6.11984 5 5.27976 5.32698 4.63803C5.6146 4.07354 6.07354 3.6146 6.63803 3.32698C7.27976 3 8.11984 3 9.8 3H14.2C15.8802 3 16.7202 3 17.362 3.32698C17.9265 3.6146 18.3854 4.07354 18.673 4.63803C19 5.27976 19 6.11984 19 7.8V21L12 17L5 21V7.8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </button>
                  </>
                }
                {
                  validUserCreds() != true ? 
                  <button className="subscribe" style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center"}} onClick={() => {generateResume(index)}}>
                    Generate Resume
                  </button>
                  : undefined
                }
                </section>
              </article>
            ))}
            { searchingListing == true || listings == undefined || listings.length <= 0 ?
              undefined
              :
              <nav className='pageControls'>
                {cPageNumber > 1 && totalListingCount > pageSize ? <Link className="navPageLinks" to={`/${curPath.toLowerCase().startsWith("/suggested") ? "suggested" : "home"}/${typeof(search) == "string" && search.length > 0 ? search.replaceAll(" ", "_")  + "/": ""}${cPageNumber - 1}/${pageSize}`}>{"<"}</Link> : undefined}
                {pageNavigationLinks}
                
                {cPageNumber <= maxPageCount ? 
                  <>
                  {(cPageNumber + 1) * pageSize >= 60  && validUserCreds() != true ? 
                    <button onClick={() => {setPopup({type: "login", "msg": "Login to see more!"});}} style={{backgroundColor: "transparent", fontWeight: "normal"}}> {">"}</button> 
                    : 
                    <Link className="navPageLinks" to={`/${curPath.toLowerCase().startsWith("/suggested") ? "suggested" : "home"}/${typeof(search) == "string" && search.length > 0 ? search.replaceAll(" ", "_")  + "/": ""}${cPageNumber + 1}/${pageSize}`}>{">"}</Link> 
                  }
                  </>
                  : undefined}
              </nav>
            }

        </section>
        <section className='directingNav' style={curPath.toLowerCase().startsWith("/suggested") ? {display: "none"} : undefined }>
          { validUserCreds() == true ?
            <Link to="/suggested" className='next'
              style={{
                borderRadius: "5px",
                padding: "5px 10px",
                textAlign: "center",
                fontWeight: "bold"
              }}
            >View Suggested Jobs</Link>
          : undefined }
          <form 
            onSubmit={handleSubmit(applyFilters)}
            className={filterMenuVis == true? "filterMenu" : "filterMenu hide"}
          >
            <button className="filterMenuExit" type="button" onClick={() => {setFilterMenuVis(false)}}>x</button>
            <h2 className="filterHeader">Apply Filters</h2>
            <section className="filters">
              <h4 style={{"textAlign": "left", width: "100%"}}>Date Posted</h4>
              <Controller
                name="date_posted_option"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <div className="datePosted">
                    <input 
                      type="radio" 
                      id="date_posted_1" 
                      checked={value === 0}
                      name="date_posted_option"
                      onChange={() => onChange(0)}
                      style={{display: "inline-block"}}
                      />
                    <label htmlFor="date_posted_1">Past 24 hours</label>

                    <input 
                      {...register("date_posted_option", { setValueAs: v => parseInt(v, 10) })} 
                      type="radio" 
                      id="date_posted_2" 
                      checked={value === 1}
                      name="date_posted_option"
                      onChange={() => onChange(1)}
                      style={{display: "inline-block"}}
                      />
                    <label htmlFor="date_posted_2">Past Week</label>

                    <input 
                      {...register("date_posted_option", { setValueAs: v => parseInt(v, 10) })} 
                      type="radio" 
                      id="date_posted_3" 
                      checked={value === 2}
                      name="date_posted_option"
                      onChange={() => onChange(2)}
                      style={{display: "inline-block"}}
                      />
                    <label htmlFor="date_posted_3">Past Month</label>
                  </div>
              )}/>
              <h4 style={{"textAlign": "left", width: "100%"}}>Location</h4>
              <input {...register("location")} placeholder='Enter location: city, state, country, or remote'></input>
            </section>
            <div className="filterControls">
              <button className="submit" type="submit">Apply</button>
              <button className="default" type="button" onClick={() => {resetFilters(); setFilterMenuVis(false)}}>Reset</button>
            </div>
          </form>
        </section>
      </main>
    </>
  )
}

export default SuggestedListings;